import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#08111F] p-6 text-white">
      <div data-testid="payment-cancel" className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.03] p-8 text-center">
        <XCircle size={56} weight="fill" className="mx-auto text-white/40" />
        <h1 className="mt-5 font-display text-2xl font-semibold">Payment canceled</h1>
        <p className="mt-2 text-sm text-white/60">No charge was made. You can try adding funds again whenever you're ready.</p>
        <button data-testid="back-wallet" onClick={() => navigate("/app/wallet")}
          className="mt-6 w-full rounded-full bg-primary py-3.5 font-semibold text-primary-foreground transition-transform hover:scale-[1.02]">Back to Wallet</button>
        <button data-testid="cancel-ask-iyeneh" onClick={() => navigate("/app/ai-sales")}
          className="mt-3 w-full rounded-full border border-white/15 py-3 text-sm font-semibold text-white/80 transition-colors hover:bg-white/5">
          Need help completing your purchase? Ask iYeneh
        </button>
      </div>
    </div>
  );
}
